import { render } from "./RegistrationEmployee.vue?vue&type=template&id=8bc42e60"
import script from "./RegistrationEmployee.vue?vue&type=script&lang=js"
export * from "./RegistrationEmployee.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__